<template>
	<view class="fright-forwarder-details">
		<view class="details">
			<view class="title"><text>货代信息</text></view>
			<view class="">
				<uni-table border stripe emptyText="暂无更多数据">
					<uni-tr>
						<uni-th align="left">姓名</uni-th>
						<uni-td align="left">测试</uni-td>
					</uni-tr>
					<uni-tr>
						<uni-th align="left">电话</uni-th>
						<uni-td align="left">18888888888</uni-td>
					</uni-tr>
					<uni-tr>
						<uni-th align="left">性别</uni-th>
						<uni-td align="left">男</uni-td>
					</uni-tr>
					<uni-tr>
						<uni-th align="left">公司名称</uni-th>
						<uni-td align="left">河北旭阳营销</uni-td>
					</uni-tr>
				</uni-table>
			</view>
		</view>
		<view class="details">
			<view class="title"><text>统计信息</text></view>
			<view class="">
				<uni-table border stripe emptyText="暂无更多数据">
					<uni-tr>
						<uni-th align="left">注册时间</uni-th>
						<uni-td align="left">2022/04/09</uni-td>
					</uni-tr>
					<uni-tr>
						<uni-th align="left">管理车辆</uni-th>
						<uni-td align="left">24辆</uni-td>
					</uni-tr>
					<uni-tr>
						<uni-th align="left">任务总数</uni-th>
						<uni-td align="left">20</uni-td>
					</uni-tr>
					<uni-tr>
						<uni-th align="left">执行完成</uni-th>
						<uni-td align="left">10</uni-td>
					</uni-tr>
				</uni-table>
			</view>
		</view>
	</view>
</template>

<script>
export default {
	onLoad(params) {
		this.huoDaiId = params.huoDaiId;
	},
	data() {
		return {
			huoDaiId: null
		};
	},
	onShow() {
		this.init();
	},
	methods: {
		init() {
			this.getHuoDaiDetail();
		},
		getHuoDaiDetail() {
			this.$reqGet('getHuoDaiDetail', { huoDaiId: this.huoDaiId }).then(res => {
				console.log(res, '货代详情');
			});
		}
	}
};
</script>

<style lang="scss" scoped>
::v-deep.fright-forwarder-details {
	width: 94%;
	margin: 0 auto;
	.details {
		margin-top: vww(24);
		.title {
			color: #111111;
			font-weight: 400;
			border: 1px solid #eeeeee;
			padding: 0 vww(12) 0 vww(12);
			border-bottom: none;
			height: vww(40);
			line-height: vww(40);
			background-color: #f5f5f5;
		}
			.uni-table {
				min-width: 0 !important;

				.uni-table-tr {
					padding: 0;
					font-size: vww(16);
					font-weight: 300;
					.uni-table-th {
						height: vww(40);
						line-height: vww(30);
						padding: vww(5) vww(10);
						color: #333333;
						font-weight: 400;
					}

					.uni-table-td {
						height: vww(40);
						line-height: vww(30);
						padding: vww(5) vww(10);
						color: #333333;
					}
				}
			}
	}
}
</style>
